//@flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import { useProvider } from 'common/modules/provider';

type Props = {
    i18nKey: string
};

const Title = ({ i18nKey }: Props): React.Node => {
    const { providerName } = useProvider();
    const { t } = useTranslation();
    const title = t(i18nKey, {
        dashboard: providerName ? t('planningDashboard') : t('locusDashboard')
    });
    return (
        <Helmet defer={false}>
            <title>{title}</title>
        </Helmet>
    );
};

export default Title;
